import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from 'src/App.vue'
import router from 'src/router'
import AntDesign from 'ant-design-vue'
import 'src/styles/base.less'
import 'ant-design-vue/dist/antd.css'
import VueDiff from 'vue-diff'

import 'vue-diff/dist/index.css'

createApp(App)
  .use(createPinia().use(piniaPluginPersistedstate))
  .use(router)
  .use(AntDesign)
  .use(VueDiff, { componentName: 'VueDiff' })
  .mount('#app')
